import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { View, TextStyle, ImageBackground } from 'react-native'
import { Gesture, GestureDetector } from 'react-native-gesture-handler'
import Config from 'react-native-config'
import { runOnJS } from 'react-native-reanimated'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useStyleSheet, StyleService } from '@src/style/service'
import { Button } from '@components/base'
import { Feature, LinearGradient, NutrisenseLogo, useFeatureFlag } from '@components'
import { Debug } from '@config'
import { runnerFullImage } from '@src/assets/images'

export const SignInOrSignUp = () => {
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation()

  const skipProgramSelectionBeforeSignUp = useFeatureFlag(Feature.SkipProgramSelectionBeforeSignUp)

  const onSignUpPress = () => {
    if (!skipProgramSelectionBeforeSignUp) {
      navigation.navigate('OnboardingSubscriptionOptions')
      return
    }

    navigation.navigate('CreateAccountOptionsStelo')
  }

  const onSignInPress = () => {
    navigation.navigate('SignIn')
  }

  const onAdminPress = () => {
    navigation.navigate('ShowAdmin')
  }

  const longPressGesture = Gesture.LongPress()
    .enabled(Debug.useAdminMenu && Config.ENV !== 'production')
    .minDuration(50)
    .onEnd((_, success) => {
      if (success) {
        runOnJS(onAdminPress)()
      }
    })

  const gradientColor = styles.buttonsContainer.backgroundColor as string

  const insets = useSafeAreaInsets()

  return (
    <View style={styles.container}>
      <View style={styles.imageContainer}>
        <ImageBackground
          source={runnerFullImage.imageSource}
          style={styles.imageBackground}
          resizeMode="cover"
        />
      </View>
      <GestureDetector gesture={longPressGesture}>
        <View style={styles.logoContainer}>
          <NutrisenseLogo
            fill={(styles.logoText as TextStyle).color}
            width={288}
            height={44}
            viewBox="0 0 240 37"
          />
        </View>
      </GestureDetector>
      <View style={styles.contentContainer}>
        <LinearGradient
          start={{ x: 0, y: 0 }}
          end={{ x: 0, y: 1 }}
          startColor={gradientColor}
          startOpacity={0}
          endColor={gradientColor}
          endOpacity={1}
          style={styles.gradient}
        />
        <View style={[styles.buttonsContainer, { paddingBottom: insets.bottom + 16 }]}>
          <Button type="primary" size="block" accessibilityLabel="Sign Up" onPress={onSignUpPress}>
            Sign Up
          </Button>
          <Button
            type="transparent"
            size="block"
            accessibilityLabel="Already have an account"
            onPress={onSignInPress}
          >
            Already have an account
          </Button>
        </View>
      </View>
    </View>
  )
}

const themedStyle = StyleService.create({
  container: {
    flex: 1,
  },
  imageContainer: {
    width: '100%',
    position: 'absolute',
    height: '87%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoContainer: {
    position: 'absolute',
    alignSelf: 'center',
    top: '15%',
    zIndex: 1,
  },
  contentContainer: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  gradient: {
    height: 100,
  },
  logoText: {
    color: 'theme.solid.white',
  },
  buttonsContainer: {
    backgroundColor: 'theme.background',
    paddingHorizontal: 24,
    gap: 8,
  },
  imageBackground: {
    width: '100%',
    flex: 1,
  },
})
